import React from 'react';
import { clsx } from 'clsx';
import { ToggleSwitch } from '../ToggleSwitch';
import styles from './ToggleSwitchCard.module.scss';

export interface ToggleSwitchCardProps {
  /**
   * Additional CSS class name
   */
  className?: string;

  /**
   * Additional CSS class name for the label
   */
  labelClassName?: string;

  /**
   * Whether this is the "select all" card
   */
  isSelectAll?: boolean;

  /**
   * Whether the toggle is checked
   */
  checked?: boolean;

  /**
   * Whether the toggle is disabled
   */
  disabled?: boolean;

  /**
   * Label text for the terms
   */
  label: string;

  /**
   * Description text below the label
   */
  description?: string;

  /**
   * Link text for terms (optional)
   */
  linkText?: string;

  /**
   * Link URL for terms (optional)
   */
  linkUrl?: string;

  /**
   * Callback when toggle state changes
   */
  onChange?: (checked: boolean) => void;

  /**
   * Test ID for testing
   */
  testId?: string;
}

export function ToggleSwitchCard({
  className,
  labelClassName,
  isSelectAll = false,
  checked = false,
  disabled = false,
  label,
  description,
  onChange,
  testId,
}: ToggleSwitchCardProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.checked);
  };

  const handleCardClick = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  const handleToggleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const cardClasses = clsx(
    styles.card,
    {
      [styles.selectAll]: isSelectAll,
      [styles.checked]: checked,
      [styles.disabled]: disabled,
    },
    className
  );

  return (
    <div className={cardClasses} onClick={handleCardClick}>
      <div onClick={handleToggleClick}>
        <ToggleSwitch
          checked={checked}
          disabled={disabled}
          label={label}
          labelClassName={labelClassName}
          onChange={handleChange}
          testId={testId}
          className={styles.toggle}
        />
      </div>
      {description && <p className={styles.description}>{description}</p>}
    </div>
  );
}
